import { useContext } from 'react';
import { ThemeContext } from './ThemeContext';
import type { Theme } from './theme';

/** Returns the current mini-app theme provided by the host via SDKProvider. */
export function useTheme(): Theme {
  return useContext(ThemeContext);
}
